(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/internal/shared/filter-campaigns.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/internal/shared/filter-campaigns.js');

'use strict';

let productMapping;
let DRAW_STATE;
let DRAW_TYPE;
let getValidProduct;
function isRelevantCampaign(campaign) {
  return getValidProduct(campaign.products[0].productId) && (
  campaign.drawTypeId !== DRAW_TYPE.CAMPAIGN || campaign.drawStateId > DRAW_STATE.DEFINED);
}
function filterCampaignsByDrawTypeId(campaigns, drawTypeIds) {
  return campaigns.filter(campaign => drawTypeIds.includes(campaign.drawTypeId));
}
function filterCampaignsByDrawStateId(campaigns, drawStateIds) {
  return campaigns.filter(campaign => drawStateIds.includes(campaign.drawStateId));
}
function isAnyDrawIncluded(drawNumber, drawCount, campaignDraws) {
  const isDrawIncluded = (drawNumber, _ref) => {
    let startDrawNumber = _ref.startDrawNumber,
      endDrawNumber = _ref.endDrawNumber;
    return drawNumber >= startDrawNumber && drawNumber <= endDrawNumber;
  };
  let isIncluded = false;
  for (let i = 0; i < drawCount; i++) {
    if (isDrawIncluded(drawNumber + i, campaignDraws)) {
      isIncluded = true;
      break;
    }
  }
  return isIncluded;
}
function filterCampaignsByDraw(campaigns, draws) {
  return campaigns.filter(campaign => draws.find(draw => {
    var _draw$drawCount;
    return isAnyDrawIncluded(draw.drawNumber, (_draw$drawCount = draw.drawCount) !== null && _draw$drawCount !== void 0 ? _draw$drawCount : 1, campaign.products.find(_ref2 => {
      let productId = _ref2.productId;
      return productMapping.isSameProduct(draw.productItsId, productId);
    }));
  }));
}
function isWithinInterval(date, interval) {
  const start = new Date(interval.startDate);
  const end = dateFns.endOfDay(new Date(interval.endDate));
  return dateFns.isWithinInterval(new Date(date), {
    start,
    end
  });
}
function filterCampaignsByDate(campaigns, date) {
  return campaigns.filter(campaign => isWithinInterval(date, campaign));
}
function filterCampaignsByEndDateInterval(campaigns, endDateInterval) {
  return campaigns.filter(campaign => isWithinInterval(campaign.endDate, endDateInterval));
}
function filterCampaignsByInterval(campaigns, dateInterval) {
  const start = new Date(dateInterval.startDate);
  const end = new Date(dateInterval.endDate);
  return campaigns.filter(campaign => dateFns.areIntervalsOverlapping({
    start,
    end
  }, {
    start: new Date(campaign.startDate),
    end: dateFns.endOfDay(new Date(campaign.endDate))
  }));
}
const filterCampaigns = {
  isRelevantCampaign,
  filterCampaignsByDrawTypeId,
  filterCampaignsByDrawStateId,
  filterCampaignsByDraw,
  filterCampaignsByDate,
  filterCampaignsByEndDateInterval,
  filterCampaignsByInterval
};
if (svs.isServer) {
  const path = require('path');
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  var _trinidad$components$ = trinidad.components.require('numbergames', 'product-mapping');
  productMapping = _trinidad$components$.productMapping;
  var _require = require(path.join(__dirname, '../../constants.es6'));
  DRAW_STATE = _require.DRAW_STATE;
  DRAW_TYPE = _require.DRAW_TYPE;
  var _require2 = require(path.join(__dirname, 'utils.es6'));
  getValidProduct = _require2.getValidProduct;
  module.exports = filterCampaigns;
} else {
  productMapping = svs.numbergames.productMapping;
  var _svs$numbergames$camp = svs.numbergames.campaign.CONSTANTS;
  DRAW_STATE = _svs$numbergames$camp.DRAW_STATE;
  DRAW_TYPE = _svs$numbergames$camp.DRAW_TYPE;
  getValidProduct = svs.numbergames.campaign.internal.utils.getValidProduct;
  svs.numbergames.campaign.internal.filterCampaigns = filterCampaigns;
}

 })(window);